import { render, staticRenderFns } from "./LegalSearch.vue?vue&type=template&id=e4befcd8&scoped=true&"
import script from "./LegalSearch.vue?vue&type=script&lang=js&"
export * from "./LegalSearch.vue?vue&type=script&lang=js&"
import style0 from "./LegalSearch.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LegalSearch.vue?vue&type=style&index=1&id=e4befcd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4befcd8",
  null
  
)

export default component.exports